import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';
import {CustomTimestampAdapter} from '@models/adminstration/organization/constants/date-picker/custom-timestamp-adapter';
import {CustomLocalizationAdapter} from '@models/adminstration/organization/constants/date-picker/custom-localization-adapter';
import {CustomDateFormatter} from '@models/adminstration/organization/constants/date-picker/custom-date-formatter';
import {ConstantComponent} from '@components/administration/organization/configuration/constants/constant.component';
import {ConstantValueItemComponent} from '@components/administration/organization/configuration/constants/constant-modal/constant-value-item/constant-value-item.component';
import {ConstantActionsComponent} from '@components/administration/organization/configuration/constants/constant-actions/constant-actions.component';
import {ConstantModalComponent} from '@components/administration/organization/configuration/constants/constant-modal/constant-modal.component';
import {ConstantValuesEditorComponent} from '@components/administration/organization/configuration/constants/constant-modal/constant-values-editor/constant-values-editor.component';


@NgModule({
  declarations: [
    ConstantComponent,
    ConstantValueItemComponent,
    ConstantActionsComponent,
    ConstantModalComponent,
    ConstantValuesEditorComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    SharedModule,
    FormsModule
  ], exports: [
    ConstantComponent
  ], providers: [
    {provide: NgbDateAdapter, useClass: CustomTimestampAdapter},
    {provide: NgbDatepickerI18n, useClass: CustomLocalizationAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateFormatter}
  ]
})
export class ConstantsModule {
}
